import { Routes } from "@angular/router";
import { MAIN_LAYOUT_ROUTES } from "./Main-layout/main-layout";

export const APP_ROUTES: Routes = [
  {
    path: 'home/details/:id',
    loadChildren: () => MAIN_LAYOUT_ROUTES,
  },
  {
    path: "",
    loadChildren: () => MAIN_LAYOUT_ROUTES
  },
  {
    path: "**",
    redirectTo: "error/not-found"
  }
];
